import { getClientUsers, FlipPageService, CustomToastrAction, Button, cursorNone, Image } from "@/imports-files/pages/clients/candidates/kanban";
import PageStyle from "@/styles/pages/kanban/_index.module.scss";
import { flipLane } from "@/actions/components/kanbanComponents/flip-back-page";

export class FlipPageAction {
  constructor(router, setUsers) {
  	this.router = router
    this.setUsers = setUsers
    this.customToastrAction  =   new CustomToastrAction();
  }

  async addRemoveMember(event, members, job_id, job_stage_id, jobData, setJobData, setFlagForRerender) {
    let params = {
      member_emails: members.map((member) => member.email)
    }
    const result = await new FlipPageService().addRemoveMember(params, job_id, job_stage_id)
    const status_code = result.status || result.response.status;
    if(status_code == 200){
      jobData.lanes.map(lane => {
        if(lane.id.toString() == job_stage_id.toString()){
          lane.members = result.data.members
        }    
        return lane;
      })
      await setJobData(jobData)
      await flipLane(event)
      await setFlagForRerender(Math.random * 10000)
      this.customToastrAction.setNormalToastr('Member(s) updated successfully', 'success');
    }
    else{
      if(result.response.data.error?.job_stage?.member_emails)this.customToastrAction.setNormalToastr(result.response.data.error.job_stage.member_emails, 'error');
    }
  }

	 getSuggestionValue(suggestion) {
    return `${suggestion.user_attributes.email}`;
  }

  showSuggestion(suggestion){
    if(suggestion.user_attributes.name && (suggestion.user_attributes.email.length > 0)){
      return `${suggestion.user_attributes.name} | ${suggestion.user_attributes.email}`
    }
    else if(suggestion.user_attributes.name){
      return `${suggestion.user_attributes.name}`
    }
    else{
      return `${suggestion.user_attributes.email}`
    }
  }

  renderSuggestion(suggestion, flipPageAction) {
    return (
      <span>{flipPageAction.showSuggestion(suggestion)}</span>
    );
  }

  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async getSuggestions(value, current_step) {
    const escapedValue = this.escapeRegexCharacters(value.trim());
    
    if (escapedValue === '') {
      return [];
    }
  
    const regex = new RegExp('^' + escapedValue, 'i');
    let finalUsers = await getClientUsers(escapedValue, current_step, this.router)
    return finalUsers
  }

  async onSuggestionsFetchRequested(value, flipPageAction, current_step){
    let users = await flipPageAction.getSuggestions(value)
    this.setUsers(users) 
  };

  shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }

  isEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  isDisabled(editable){
    return editable ? '' : 'disabled'
  }

  renderMemberInputComponent = inputProps => (
    <div className={`savebuttonin ${inputProps.flipPageAction.isDisabled(inputProps.editable)}`}>
      <input className = {PageStyle.Form__Input} autoComplete="password"
      {...inputProps} />
      <Button buttonstyle={`${PageStyle.nobgbutton} addbtn ${cursorNone(inputProps.editable)}`}  disabled={inputProps.disabled} onClick={(event) => inputProps.flipPageAction.onAddClick(event, inputProps)}>ADD</Button>
    </div>
  );

  onSuggestionSelection(members, setMembers, member_initial){
    let member_emails = members.map((x) => x.email)
    if(!member_emails.includes(member_initial.email))
     {
      members.unshift(member_initial)
      setMembers([...members])
     } 
  }

  onAddClick = (event, params) => {
    let email = params.value 
    if(this.isEmail(email)){
      params.flipPageAction.onSuggestionSelection(params.members, params.setMembers, {email: email, name_initials: null, name: null })
      params.setUserEmail('')
      params.setUserEmailError('')
    }
    else{
      params.setUserEmailError('Please enter valid email')
    }
  }

  handleKeyDown(event, members, setMembers, setUserEmailError){
    if (["Enter"].includes(event.key)) {
      event.preventDefault();
      let email = event.target.value 
      if(this.isEmail(email)){
        this.onSuggestionSelection(members, setMembers, {email: email, name_initials: null, name: null })
        setUserEmailError('')
      }
      else{
        setUserEmailError('Please enter valid email')
      }
    }
  }

  handleDelete(members, setMembers, itemIndex){
    members.splice(itemIndex, 1)
    setMembers([...members])
  };
}
